/**
 *
 *    DISCOUNT IN CART
 *    Contains all functions needed to add or remove a discount code to or from the cart
 *
 */

// Add discount code
function AddDiscountCode() {
    // After entering a discount code
    $('#btnDiscountCode').on('click', function () {
        //disabling button and showing loader
        $('#btnDiscountCode').attr('disabled', true);
        $('#loaderdiscount').removeClass('hidden');

        //Removing any errors if there were any to try again
        $('#discountcode-error').remove();
        $('#txtDiscountCode').removeClass('is-invalid');

        //check if a text was given
        if ($('#txtDiscountCode').val() == '') {
            // Show error
            $('#txtDiscountCode').addClass('is-invalid');
            var error = $('<label id=\'discountcode-error\' class=\'invalid-feedback\' for="txtDiscountCode">' + $('#txtDiscountCode').data('error') + '</label>');
            $('form#frmDiscount').after(error);

            //enabling button and removing loader
            $('#btnDiscountCode').attr('disabled', false);
            $('#loaderdiscount').addClass('hidden');
        } else {
            // Validate discount code
            var strParams = 'strAction=add&intAddressNo=' + intAddressNo + '&strDiscountCode=' + $('#txtDiscountCode').val();
            $.post(strAjaxPath + 'cart/discount.php', strParams, function (arrObjecten) {
                if (arrObjecten.value == 0) {
                    if (arrObjecten.popuplogin) {
                        // Show popup login (if gift card and not logged in)
                        var objALogin = $('<a href="' + arrObjecten.message + '" class="popuplogin"></a>');
                        $('form#frmDiscount').append(objALogin);
                        // Open 'Product added' popup
                        objALogin.fancybox({
                            type: 'iframe',
                            width: 800,
                            height: 600, // Hoogte is verplicht voor iframes
                            autoFocus: false,
                            touch: {
                                vertical: false,
                                momentum: false,
                            },
                            animationEffect: false,  // Vervangt transitionIn: 'none'
                            transitionEffect: false, // Vervangt transitionOut: 'none'
                            iframe: {
                                preload: true,
                                css: {
                                    width: '800px',
                                    height: '600px',
                                },
                            },
                            // Vervangt helpers.overlay.locked: false
                            modal: false,
                            closeExisting: false,
                            // Callback after fancybox closes
                            afterClose: function () {
                                // Enabling button and removing loader
                                $('#btnDiscountCode').attr('disabled', false);
                                $('#loaderdiscount').addClass('hidden');
                            },
                        });

                        objALogin.click();
                    } else {
                        // Show error
                        $('#txtDiscountCode').addClass('is-invalid');
                        var error = $('<label id=\'discountcode-error\' class=\'invalid-feedback\' for="txtDiscountCode">' + arrObjecten.message + '</label>');
                        $('form#frmDiscount').after(error);

                        //enabling button and removing loader
                        $('#btnDiscountCode').attr('disabled', false);
                        $('#loaderdiscount').addClass('hidden');
                    }
                } else if (arrObjecten.value == 1) {
                    // Correct code => reload page
                    document.location.reload();
                }
            }, 'json');
        }
    });

    // Also add discount code when clicking enter in input field
    $('#txtDiscountCode').keypress(function (e) {
        if (e.which == 13) {
            $(this).blur();
            return false;
        }
    });
}

// Remove discount code
function RemoveDiscountCode() {

    // Click on 'remove discount code'
    $('a[id^=remove-discount]').click(function () {

        // Remove discount code
        var arrDiscountno = $(this).attr('id').split('-');
        var strParams = 'strAction=delete&intDiscountNo=' + arrDiscountno[2];
        $.post(strAjaxPath + 'cart/discount.php', strParams, function (arrObjecten) {

            $('div.discountcode-error').remove();
            if (arrObjecten.value == 0) {
                // Show error
                var objDivBoxError = $('<div class=\'discountcode-error\'></div>');
                objDivBoxError.append('<p>' + arrObjecten.message + '</p>');
                $('form#frmDiscount').append(objDivBoxError);

            } else if (arrObjecten.value == 1) {

                // Right code => reload page
                document.location.reload();

            }

        }, 'json');

        return false;
    });
}

window.RemoveDiscountCode = RemoveDiscountCode;
window.AddDiscountCode = AddDiscountCode;
